import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetTicketTopic } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl5 + 'ticket-topic';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };
    const fills = ["#F56954", "#F39C12", 
    "#FFC107", "#D2D6DE","#65A0D1"];
    var arrayindex = []
    var fill = ""

    const response = await doFetch(url, argument);
    var data = fromJS({});
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get("ticket-topic")
        var x = []
        for (var i = 0; i < data.size; i++) {
            var intrand = Math.floor(Math.random() * fills.length)
            while (arrayindex.includes(intrand)) {
                intrand = Math.floor(Math.random() * fills.length)
            }
            fill = fills[intrand]
            arrayindex.push(intrand)
            var datinti = data.get(i)
            var topic = datinti.get("topic")
            var total = parseInt(datinti.get("total"))
            if(topic==""){
                topic = "No Topic"
                total = 1
            }
            var obj = { name: topic }
            obj["total"] = total
            obj["fill"] = fill
            obj["stroke"] = fill
            x.push(obj)

        }
        data = x
    }
    dispatch({ type: GetTicketTopic, data: fromJS(data) });
    return data
};